import React, { Component } from "react";
import { DomCustomImage, DomSelect, DomField, DomBoolCheckbox, DomCheckboxField, DomTextarea } from "../Services/formDOM";
import { checkInput, returnValue, hasValue, validateEmail } from "../Services/Validation";
import { apiURL, Environment } from "../Services/Base";
import Loading from "../Services/Loading/Loading";
import "./Form.scss"
import { GA_Push } from "../Services/GoogleAnalytics";

export default class Form extends Component {
  constructor(props) {
    super();
    this.state = {
      isBusy: false,
      isLoading: false,
      postMessage: null,
      captchaEnable: !Environment().isLocalhost,
      ImagePlaceholder: "העלאת תמונה של המנה <span>(JPG, PNG, GIF)</span>",
    }

    window.sendCallback = this.sendForm;
  }

  componentDidMount() {
    (() => {
      if (window.document.getElementById("GoogleRecap")) return;

      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.id = "GoogleRecap";
      script.async = 1;
      script.defer = 1;
      script.src = 'https://www.google.com/recaptcha/api.js';

      document.getElementsByTagName('head')[0].appendChild(script);
    })();
  }
  handleInputChange = event => {
    const handleChange = {
      [event.target.name]: {
        ...this.state[event.target.name],
        error: "",
        value: (event.target.dataset && event.target.dataset.bool === "true" ? (this.state[event.target.name].value ? 0 : 1) : event.target.value)
      }
    }
    this.setState(handleChange);
  }
  changeImageLabel = (event) => {
    var allowdExtensions = ["jpg", "jpeg", "gif", "png"];
    var file = event.target.files[0];
    if (file) {
      if (file.size > 5242880) {
        alert("לא ניתן להעלות קבצים מעל 5mb")
        event.target.value = "";
        return false;
      }

      var isAllowd = false;
      allowdExtensions.forEach((extension) => {
        if (file.type.indexOf(extension) > -1) {
          isAllowd = true;
        }
      })

      if (!isAllowd) {
        alert("ניתן לעלות רק קבצי תמונה");
        event.target.value = "";
        return false;
      }

      this.setState({
        ImagePlaceholder: file.name,
        FileName: {
          ...this.state.FileName,
          name: file.name,
          value: file,
          error: "",
          label: "",
          id: "FileName"
        }
      })
    } else {
      return false;
    }
  }

  addState = (stateName, isRequired, stateId) => {
    this.setState({
      [stateName]: {
        name: stateName,
        value: "",
        label: "",
        id: stateId,
        isRequired: !isRequired ? false : true
      }
    })
  }
  setErrorMessage = (target, errorMsg) => {
    if (!this.state[target.name]) return;

    this.setState({
      [target.name]: {
        ...target,
        error: errorMsg
      }
    });
  }

  saveAndValidate = async () => {
    if (this.state.isBusy) return;

    this.setState({
      isLoading: true,
      isBusy: true
    });

    delete this.state.postMessage;
    let isError = false,
      j = 0,
      jsonBody = {},
      state = Object.filter(this.state, s => s.isRequired),
      fieldStateKeys = Object.keys(state);

    for (let s in state) {
      if (await !checkInput(state[s], this.setErrorMessage)) isError = true;
      j++;
    }

    for (let k in fieldStateKeys) {
      jsonBody = Object.assign(jsonBody, {
        [fieldStateKeys[k]]: returnValue(state[fieldStateKeys[k]])
      });
    }

    if (isError && j == fieldStateKeys.length) {
      this.setState({
        isLoading: false,
        isBusy: false
      })
      return;
    }

    this.setState({
      jsonBody,
      isLoading: true,
      isBusy: true
    }, () => this.state.captchaEnable ? window.grecaptcha.execute() : this.sendForm())
  }
  sendForm = async () => {
    let formData = new FormData();
    let formDataEmailPhone = new FormData();
    const { jsonBody } = this.state;

    for (let k = 0; k < Object.keys(jsonBody).length; k++) {
      let _key = Object.keys(jsonBody)[k];
      formData.append(_key, jsonBody[_key]);
      if (_key == "PhoneNumber" || _key == "Email") {
        formDataEmailPhone.append(_key, jsonBody[_key]);
      }
    }

    this.state.captchaEnable ? window.grecaptcha.reset() : null;

    let isExists = await fetch(`${apiURL}IsExists`, {
      method: 'POST',
      body: formDataEmailPhone
    }).then(data => data.json());

    if (isExists) {
      this.setState({
        isLoading: false,
        isBusy: false,
        postMessage: {
          type: "error",
          message: "נראה שהפרטים שהזנת כבר נמצאים במאגר. לא ניתן לשלוח פעם נוספת."
        }
      })
      this.props.setPage("popup");
      // ALREADY EXISTS
      return;
    }

    fetch(`${apiURL}Save`, {
      method: 'POST',
      body: formData
    }).then(data => data.json())
      .then(data => {
        this.setState({
          isLoading: false,
          isBusy: false,
          postMessage: {
            type: "success",
            message: "טופס נשלח בהצלחה!"
          }
        })
        this.props.setPage("popup");
        //THANKYOU
        GA_Push("form_sent");
        if (this.state.captchaEnable) {
          window.grecaptcha.reset();
        }
      }).catch(error => {
        this.setState({
          isLoading: false,
          isBusy: false
        });
      });
  }
  render() {
    return (
      <section className="section section-form">
        <div className="padding">
          <div className="container">
            {this.state.postMessage != null ?
              <div className={`message ${this.state.postMessage.type}`}>
                {this.state.postMessage.message}
              </div> : ""}
            <Loading showLoading={this.state.isLoading} />
            <div className={`fields ${this.state.postMessage != null && "hide"}`}>
              <DomField
                type="text"
                max={64}
                label="שם המתכון"
                placeholder="שם המתכון"
                name="RecipeName"
                id="RecipeName"
                className=""
                isRequired
                onChange={this.handleInputChange}
                onLoad={this.addState}
                {...this.state} />
              <DomTextarea
                type="text"
                label="מרכיבים ואופן ההכנה"
                placeholder="מרכיבים ואופן ההכנה"
                name="RecipeSteps"
                id="RecipeSteps"
                className=""
                isRequired
                onChange={this.handleInputChange}
                onLoad={this.addState}
                {...this.state} />
              <DomCustomImage name="FileName" id="FileName" placeholder={this.state.ImagePlaceholder}
                isRequired
                onChange={this.changeImageLabel}
                onLoad={this.addState}
                {...this.state} />
              <div className="row">
                <div className="right">
                  <DomField
                    type="text"
                    max={64}
                    label="שם מלא"
                    placeholder="שם מלא"
                    name="FullName"
                    id="FullName"
                    className=""
                    isRequired
                    onChange={this.handleInputChange}
                    onLoad={this.addState}
                    {...this.state} />
                  <DomField
                    type="text"
                    max={64}
                    label="טלפון"
                    placeholder="טלפון"
                    name="PhoneNumber"
                    id="PhoneNumber"
                    className=""
                    isRequired
                    onChange={this.handleInputChange}
                    onLoad={this.addState}
                    {...this.state} />
                  <DomField
                    type="text"
                    max={64}
                    label={`דוא"ל`}
                    placeholder={`דוא"ל`}
                    name="Email"
                    id="Email"
                    className=""
                    isRequired
                    onChange={this.handleInputChange}
                    onLoad={this.addState}
                    {...this.state} />
                </div>
                <div className="left">
                  <DomBoolCheckbox
                    type="checkbox"
                    name="Terms"
                    id="Terms"
                    className="field"
                    label={`קראתי, הבנתי, ומסכים <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/terms.html" target="_blank">לתנאי השימוש</a>, <a href="https://z.ynet.co.il/short/content/2018/privacypolicy/policy.html" target="_blank">למדיניות הפרטיות</a> ו<a href=${`https://z.ynet.co.il/mShort/commerce/API/TaraShavuot/takanon.htm`} target="_blank">לתקנון הפעילות</a>, וכן נותן הסכמתי למשלוח דברי פרסום לפי פרטיי לעיל`}
                    value="0"
                    isRequired
                    onChange={this.handleInputChange}
                    onLoad={this.addState}
                    {...this.state}
                  />
                  <div className="button" onClick={() => {
                    this.saveAndValidate()
                  }}>
                    <div className="text">שלח</div>
                    <div className="arrow"></div>
                    <div className="g-recaptcha"
                      data-callback="sendCallback"
                      data-size="invisible"
                      data-sitekey="6LfoC3kUAAAAAPt8XZMzr6ljG2omdMJY7z8PPhpU"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Form/Form.jsx